export const AI_WORKFLOW_ERROR_MESSAGES = {
    model_provider_unavailable: 'Der KI-Dienst ist vorübergehend nicht erreichbar. Bitte versuchen Sie es später erneut.',
    async_invocation_timed_out: 'Die Verarbeitung hat zu lange gedauert. Bitte starten Sie den Import erneut.',
    async_invocation_interrupted: 'Die Verarbeitung wurde unterbrochen. Bitte starten Sie den Import erneut.',
}
